import { StatsTeam, ValueOpt } from "best-common-react";

export const getTeamOption = (
  teamId: number | string | undefined,
  teamOptions: ValueOpt<StatsTeam>[],
): ValueOpt<StatsTeam> => {
  const teamOption =
    teamId !== undefined
      ? teamOptions.find((opt: ValueOpt<StatsTeam>) => opt.value?.id?.toString() === teamId.toString())
      : ({ label: "All", value: {} } as ValueOpt<StatsTeam>);
  return teamOption ?? ({ label: "All", value: {} } as ValueOpt<StatsTeam>);
};
